import { Directive, AfterContentInit, ElementRef, OnInit } from '@angular/core';

/**
 * focus directive
 */
@Directive({
  selector: '[appFocus]'
})
export class FocusDirective implements AfterContentInit, OnInit {
  /**
   * constructor to inject dependency
   * @param element instance of element
   */
  constructor(private element: ElementRef) {}

  /**
   * initialize component
   */
  ngOnInit() {
    setTimeout(() => {
      this.element.nativeElement.focus();
    }, 500);
  }

  /**
   * after content is initialized
   */
  ngAfterContentInit() {
    setTimeout(() => {
      this.element.nativeElement.focus();
    }, 500);
  }
}
